import {
	FETCH_EVENT_CONNECTION,
	UPDATE_EVENT_CONNECTION,
	CREATE_EVENT_CONNECTION,
	FETCH_EVENT_CONNECTIONS,
	DELETE_CONNECTION,
} from '../actions/actionTypes';

const preState = { eventConnection: null, eventConnections: [], pageInfo: {} };

const connectionsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, eventConnection, eventConnections, connectionID } = action;

	switch (type) {
		case FETCH_EVENT_CONNECTION:
			return { ...stateDup, eventConnection };
		case UPDATE_EVENT_CONNECTION:
			return { ...stateDup, eventConnection };
		case CREATE_EVENT_CONNECTION:
			return { ...stateDup, eventConnection };
		case FETCH_EVENT_CONNECTIONS:
			return {
				...stateDup,
				eventConnections: eventConnections.nodes,
				pageInfo: eventConnections.page_info,
			};
		case DELETE_CONNECTION:
			stateDup.eventConnections = stateDup.eventConnections.filter(
				connection => connection.id !== connectionID
			);
			return stateDup;
		default:
			return stateDup;
	}
};

export default connectionsReducer;
